import { ApiBaseService } from 'api/apibase.service';
import { AxiosPromise } from 'axios';
import {
  CaseCategory,
  CaseCategoryParam,
} from 'redux/case/caseCategory/case.types';
import {
  CaseItem,
  CaseOrderParam,
  CaseParams,
  FormDataType,
} from 'redux/case/caseOrder/case-order.types';
import { ZendeskResponse } from 'types/zendesk-response.types';

class CaseApiService extends ApiBaseService {
  getCaseCategoryType({
    caseCategoryId,
    isRefund,
  }: CaseCategoryParam): AxiosPromise<CaseCategory[]> {
    return this.apibase.get<CaseCategory[]>('cases/category-types', {
      params: {
        caseCategoryId,
        inactive: false,
        isRefund,
      },
    });
  }

  save(data: CaseParams): AxiosPromise<string> {
    return this.apibase.post<string>('cases', data);
  }

  submit(dataParams: FormDataType): AxiosPromise<ZendeskResponse> {
    return this.apibase.post<ZendeskResponse>(
      `${window.ZENDESK_API}`,
      dataParams,
      {
        headers: {
          'Ocp-Apim-Subscription-Key': `${window.ZENDESK_SUBSCRIPTION_KEY}`,
          'x-brand-id': `${window.ZENDESK_BRAND_ID}`,
          'x-group-id': `${window.ZENDESK_GROUP_ID}`,
          'Content-Type': 'application/json',
        },
      },
    );
  }

  getDuplicateCase(data: CaseOrderParam): AxiosPromise<CaseItem[]> {
    return this.apibase.post<CaseItem[]>('cases/check-duplicates', data);
  }
}

const caseApiService = new CaseApiService();

export { caseApiService };
